<template>
  <div class="invoice-container" id="admin-block">
   <nav class="add-navigation">
      <div class="right-wrapprr">
        <search-input
          class="search-input"
          type="text"
          v-model="SearchAdmin"
          placeholder="Search for admin"
        />
        <div class="reset-button">
          <primary-button @click.native="reasetFilters" style="width:90%;margin-left: 20px;">Reset</primary-button>
        </div>
        <div class="show-active-items">
          <input type="checkbox" id="show-active" class="active-checkbox" v-model="isActive" />
          <label for="show-active">Active Only</label>
        </div>
      </div>
      <div class="buttons-wrapper">
        <div class="primary-button">
          <primary-button @click.native="$router.push({name: 'system-admin-add-admin'})">Add Admin</primary-button>
        </div>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <template v-else>
      <not-found v-if="isFound" />
      <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th>First Name</th>
              <th>Last Name</th>
              <th>Created On</th>
              <th>Created By</th>
              <th>Username</th>
              <th>Status</th>
              <th>Action</th>
              <!-- <th></th>
              <th></th>-->
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              class="line"
              v-for="(admin, k) in adminList"
              :key="k"
            >
              <th>{{admin.first_name}}</th>
              <th>{{admin.last_name}}</th>
              <th class="break">{{dateFormat(admin.created_on)}}</th>
              <th class="break">{{admin.created_by}}</th>
              <th class="break">{{admin.user_name}}</th>
              <th class="break">{{admin.status}}</th>
              <th class="icon-right">
                <div>
                  <span title="Edit">
                    <svg
                            @click="$router.push({name: 'system-admin-edit-admin', params: {id: admin.user_id}})"
                            class="svg-grey"
                            width="30px"
                            height="30px"
                            viewBox="0 0 30 30"
                            version="1.1"
                    >
                    <path
                            d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                            id="path-1"
                    />
                  </svg>
                  </span>
                  <span title="Delete">
                    <svg
                            @click="deleteVendor(admin.user_id)"
                            class="svg-grey"
                            width="30px"
                            height="30px"
                            viewBox="0 0 30 30"
                            version="1.1"
                    >
                    <path
                            d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                            id="path-1"
                    />
                  </svg>
                  </span>
                </div>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page">
        <span class="filter_by">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
          </primary-select>
        </div>
      </div>
      <div v-if="!isFound" class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="TotalPages"
          :perPage="per_page"
          :qnt="adminList.length"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    AppDropdown: () => import("@/components/DropDowns/Dropdown.vue"),
    //bDropdown: ()=> import('bootstrap-vue/es/components/dropdown/dropdown'),
    FiltersActions: () => import("@/components/FiltersAndActions.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    showDropDown: false,
    adminList: [],
    pages: [10, 50, 100],
    per_page: 10,
    Total: null,
    TotalPages: null,
    Page: 0,
    SearchAdmin: "",
    loading: true,
    isFound: false,
    isActive: false,
  }),
  filters: {
  
    formatDate(d) {
      const date = new Date(d);
      const year = date.getFullYear();
      const _month = String(date.getMonth() + 1);
      const month = _month.length === 1 ? `0${_month}` : _month;
      const _day = String(date.getDate());
      const day = _day.length === 1 ? `0${_day}` : _day;

      return `${year}/${month}/${day}`;
    },
  },
  watch: {
    SearchAdmin: function () {
      this.Page = 0;
      this.GetAdminList();
    },
    isActive() {
      this.Page = 0;
      this.GetAdminList();
    },
  },
  created() {
    this.GetAdminList();
  },
  methods: {
    changePerPage(e) {
      this.Page = 0;
      this.GetAdminList();
    },
    changePage(page) {
      this.Page = page;
      this.GetAdminList();
    },
    reasetFilters() {
      this.SearchAdmin = "";
      this.GetAdminList();
    },
    GetAdminList() {
      this.loading = true;
      this.isFound = false;
      this.$store
        .dispatch("GetUsers", {
          page: this.Page,
          per_page: this.per_page,
          is_admin: 'admin',
          user_name: this.SearchAdmin,
          is_active: this.isActive,

        })
        .then((res) => {
          console.log("admin List -> ", res);
          if (!res.items.length) {
              this.isFound = true;
              this.loading = false;

            return;
          }
          this.adminList = res.items;
          this.per_page = res.per_page;
          this.Total = res.total;
          this.TotalPages = res.total / res.per_page;
          this.loading = false;
        });
    },

    deleteVendor(admin_id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this admin!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then(async (result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteUser", admin_id)
            .then(() => {
              this.$swal({
                title: "Deleted!",
                text: "The Admin has been deleted.",
                type: "success",
              });
              this.GetAdminList();
            })
            .catch((err) => {
              this.$error(err);
            });
        }
      });
    },
      oneToTwoDigit(num) {
      return num.length === 1 ? `0${num}` : num;
    },
    dateFormat(date) {
      if (date == null) {
        return "";
      }
      const converted_date = new Date(date);
      const year = converted_date.getFullYear().toString();
      const _month = (converted_date.getMonth() + 1).toString();
      const month = this.oneToTwoDigit(_month);
      const _day = converted_date.getDate().toString();
      const day = this.oneToTwoDigit(_day);
      const _hours = converted_date.getHours().toString();
      const hours = this.oneToTwoDigit(_hours);
      const _minutes = converted_date.getMinutes().toString();
      const minutes = this.oneToTwoDigit(_minutes);
      const _seconds = converted_date.getSeconds().toString();
      const seconds = this.oneToTwoDigit(_seconds);

      return `${year}:${month}:${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style>
#admin-block .add-navigation {
  align-items: flex-start;
}
#admin-block .add-navigation .right-wrapper {
  align-items: flex-start;
}
#admin-block .add-navigation .right-wrapper .show-active-items {
  padding: 8px 0;
}
#admin-block .add-navigation .right-wrapper .filter_by {
  margin-left: 15px;
}
</style>
<style lang="scss" scoped>
.add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .show-active-items {
    display: flex;
    align-items: center;
    margin-left: 30px;
    // padding: 15px 0;

    .active-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    label {
      width: 90px;
      margin-bottom: 0;
    }
  }
    .right-wrapprr {
      display: flex;
      align-items: center;
      width: fit-content;
      .search-input {
        height: 40px;
        width: 345px;
        background-color: #ffffff;
        margin-bottom: 0;
      }
      .reset-button {
        height: 40px;
        width: 100px;
      }
      .selects-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .filter_by {
          height: 40px;
          width: 90px;
          color: #55616e;
          font-weight: normal;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          padding: 10px 0 10px 30px;
          //margin-bottom: 10px;
        }
        .company {
          height: 40px;
          width: 150px;
          padding: 0 0 0 10px;
          color: #55616e;
          font-weight: normal;
        }
        .choose-company {
          height: 40px;
          width: 180px;
          padding: 0 10px 0 10px;
          color: #55616e;
          font-weight: normal;
        }
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
    }
  }
.invoice-container {
  padding: 0 20px;

  // .show-active-items {
  //   display: flex;
  //   align-items: center;
  //   // margin-left: 20px;
  //   padding: 15px 0;

  //   .active-checkbox {
  //     width: 20px;
  //     height: 20px;
  //     margin-right: 10px;
  //   }
  //   label {
  //     margin-bottom: 0;
  //   }
  // }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .filter_by {
      margin-right: 15px;
      color: #55616e;
      font-weight: normal;
      font-family: "Helvetica Neue";
      font-size: 14px;
    }
    .perPage {
      width: 120px;
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: 100%;

    .primary-button {
      height: 40px;
      width: 130px;
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  th {
    text-align: center;
    padding-left: 0;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  //  padding-left: 20px;
  //     padding-right: 30px;
  width: 14%;
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0px 0px 0 20px;
  margin-right: 10px;
}
th.button {
  padding: 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  //padding: 10px 15px 10px 0;
  margin: 0 auto;
  padding-right: 15px;
  height: 100%;
  float: right;
  .svg-grey {
    fill: #55616e;
    margin-right: 15px;
  }
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 44px;
  font-size: 14px;
  line-height: 20px;
  padding: 15px 0px;
  text-align: left;
}
tbody th:first-child {
    padding: 12px 0;
}
tbody th.break {
  max-width: 100px;
  word-wrap: break-word;
  padding-right: 15px;
  line-height: 20px;
  color: #55616e;
  font-family: "Helvetica Neue";
}
tbody th .did {
  width: 50px;
  height: 24px;
  line-height: 19px;
  margin-right: 2px;
  padding: 0;
}
tbody th .account {
  width: 75px;
  height: 24px;
  line-height: 19px;
  margin-right: 2px;
  padding: 0;
}
tbody th.icon-right {
  width: 190px;
  padding: 7px 0;

  div {
    display: flex;
    justify-content: flex-end;

    .did-icon {
      position: relative;
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 4px;
      border-radius: 50%;
      background: #c0c6d1;

      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 58%;

        path {
          fill: #fff;
        }
      }
    }
  }
  .svg-grey {
    fill: #55616e;
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 17px 12px 0 13px;
  cursor: pointer;
  float: left;
}

.active {
  th .status {
    background-color: #24e2b8;
  }
}
.inactive {
  background-color: #f0f1fa;
  th .status {
    background-color: #d2305b;
  }
}
.img-container {
  // display: flex;
  width: 100%;
  text-align: center;

  .name-span {
    padding: 0;
    line-height: 44px;
  }
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin: 7px 8px 7px 0;
}
.primary {
  // padding-top: 11px;
  width: 90px !important;
  height: 30px !important;
  font-size: 12px !important;
  line-height: 20px !important;
  border-radius: 100px !important;
  margin-right: 10px !important;
}
.primary.active {
  border: 2px solid #ffffff;
  border-radius: 100px;
  background-color: #24e2b8;
  color: #ffffff;
  padding: 0;
  // opacity: 0.68;
}
@media (max-width: 1519px) {
  table.Invoice_table {
    width: 1500px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

